import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Observable } from 'rxjs';
import {
  faTrash,
  faRightFromBracket,
  faTriangleExclamation,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';
import {
  ConfirmDialogService,
  ConfirmDialogState,
  ConfirmDialogIntent,
  ConfirmDialogIcon,
} from '@core/services/confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.css',
})
export class ConfirmDialogComponent {
  state$: Observable<ConfirmDialogState>;

  faTrash = faTrash;
  faRightFromBracket = faRightFromBracket;
  faTriangleExclamation = faTriangleExclamation;
  faCircleInfo = faCircleInfo;

  constructor(private confirmDialog: ConfirmDialogService) {
    this.state$ = this.confirmDialog.getState();
  }

  getIcon(icon?: ConfirmDialogIcon): any {
    switch (icon) {
      case 'trash':
        return this.faTrash;
      case 'logout':
        return this.faRightFromBracket;
      case 'info':
        return this.faCircleInfo;
      case 'warning':
      default:
        return this.faTriangleExclamation;
    }
  }

  getAccentClasses(intent?: ConfirmDialogIntent): string {
    switch (intent) {
      case 'primary':
        return 'bg-[var(--color-brand-400)]';
      case 'warning':
        return 'bg-yellow-500';
      case 'neutral':
        return 'bg-[var(--color-gray-400)]';
      case 'danger':
      default:
        return 'bg-[var(--color-error-500)]';
    }
  }

  getIconWrapperClasses(intent?: ConfirmDialogIntent): string {
    switch (intent) {
      case 'primary':
        return 'bg-[var(--color-brand-100)] text-[var(--color-brand-500)] ring-[var(--color-brand-200)]';
      case 'warning':
        return 'bg-yellow-50 text-yellow-600 ring-yellow-100';
      case 'neutral':
        return 'bg-[var(--color-gray-100)] text-[var(--color-gray-500)] ring-[var(--color-gray-200)]';
      case 'danger':
      default:
        return 'bg-red-50 text-red-600 ring-red-100';
    }
  }

  getConfirmButtonClasses(intent?: ConfirmDialogIntent): string {
    switch (intent) {
      case 'primary':
        return 'bg-[var(--color-brand-500)] hover:bg-[var(--color-brand-600)]';
      case 'warning':
        return 'bg-yellow-500 hover:bg-yellow-600';
      case 'neutral':
        return 'bg-[var(--color-gray-500)] hover:bg-[var(--color-gray-600)]';
      case 'danger':
      default:
        return 'bg-[var(--color-error-500)] hover:bg-[var(--color-error-600)]';
    }
  }

  close(): void {
    this.confirmDialog.cancel();
  }

  confirm(): void {
    this.confirmDialog.accept();
  }

  trackByOpen(_index: number, state: ConfirmDialogState): boolean {
    return state.open;
  }
}
